import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	checkboxAriaLabelNonFinal: {
		id: 'project-create-importer-upload-flow.mapping-screen.field-mapping.include-in-import.checkbox-aria-label-non-final',
		defaultMessage: 'Include {fieldName} in import',
		description: 'Placeholder for field selector',
	},
});
